module.exports = __webpack_public_path__ + "static/instagram-75a930d5c0091d4a7e97b1cd78541df6.png";